export enum FileSizeTypeEnum {
  KB = 1,
  MB,
}
